import { render, staticRenderFns } from "./milanWinterGamesFull_WOG.vue?vue&type=template&id=b068ec88"
import script from "./milanWinterGamesFull_WOG.vue?vue&type=script&lang=js"
export * from "./milanWinterGamesFull_WOG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports